import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import LandingNavbar from '../../components/LandingNavbar';
import LandingFooter from '../../components/LandingFooter';
import '../LandingPage.css';

const BudgetPlannerIndia = () => {
  return (
    <div className="seo-page">
      <Helmet>
        <title>Budget Planner App India | Monthly Budget Banao | Hisab OK Hai</title>
        <meta name="description" content="India ke liye best budget planner app. Category-wise budget set karein, alerts paayein, aur monthly expenses control mein rakhein. Free budget planning tool." />
        <meta name="keywords" content="budget planner india, budget app india, monthly budget planner, budget tracker india, money budget app, personal budget india, category budget app" />
        <link rel="canonical" href="https://hisabokhai.in/budget-planner-india" />
      </Helmet>

      <LandingNavbar />

      <section className="seo-page-hero">
        <h1>Budget Planner App for India — Monthly Budget Banao Aur Follow Karo</h1>
        <p>Category-wise budget set karein, spending track karein, aur mahine ke end mein surprise se bachein. Simple aur free.</p>
        <Link to="/signup" className="cta-primary">Free Mein Try Karein</Link>
      </section>

      <div className="seo-content">
        <h2>Budget Planning Kyun Zaroori Hai?</h2>
        <p>
          Bina budget ke paisa control karna impossible hai. Salary aati hai aur pata nahi chalta kahan chali jaati hai.
          Budget planning se aap decide karte ho ki kitna kahan kharcha karna hai — aur phir usse follow karte ho.
          Yeh ek simple habit hai jo financial freedom ki taraf le jaati hai.
        </p>

        <h2>Hisab OK Hai Ka Budget Feature</h2>
        <p>
          Hisab OK Hai mein built-in budget planner hai jo aapko category-wise monthly budgets set karne deta hai.
        </p>
        <ul>
          <li>Category-wise budget set karein — food, transport, shopping, rent etc.</li>
          <li>Real-time tracking — budget kitna use hua, kitna baaki hai</li>
          <li>Budget alerts — limit ke paas pahunchne pe warning</li>
          <li>Monthly comparison — pichhle mahine se compare karein</li>
          <li>Visual progress bars — ek nazar mein samjho spending status</li>
          <li>Overspending insights — kahan zyada kharcha ho raha hai</li>
        </ul>

        <h2>Kaise Budget Set Karein?</h2>
        <p>
          App mein budget section pe jao, category select karo, monthly limit set karo — bas!
          Jaise jaise expenses add hoge, budget automatically update hoga. Aur jab limit ke paas pahunchoge,
          alert mil jayega.
        </p>

        <h2>Budget + Expense Tracking = Full Control</h2>
        <p>
          Hisab OK Hai sirf budget planner nahi hai — yeh expense tracker, udhari manager, vendor tracker,
          aur reminder system bhi hai. Sab ek jagah milne se aapko apne finances ka complete picture milta hai.
          Budget banao, follow karo, aur paison pe pura control rakho.
        </p>

        <div className="seo-cta-box">
          <h3>Try Hisab OK Hai for Free</h3>
          <p style={{color: '#555', marginBottom: '16px'}}>Apna pehla budget abhi banayein — free signup, instant access.</p>
          <Link to="/signup" className="cta-primary">Free Sign Up</Link>
          <div style={{marginTop: '12px'}}>
            <Link to="/login" style={{color: '#27AE60', fontSize: '0.9rem'}}>Already have an account? Login</Link>
          </div>
        </div>

        <div className="seo-internal-links">
          <h3>Explore More Features</h3>
          <div className="seo-links-grid">
            <Link to="/" className="seo-link-card">
              <span className="seo-link-icon">&#127968;</span> Home
            </Link>
            <Link to="/expense-tracker-india" className="seo-link-card">
              <span className="seo-link-icon">&#128176;</span> Expense Tracker
            </Link>
            <Link to="/daily-expense-tracker" className="seo-link-card">
              <span className="seo-link-icon">&#128197;</span> Daily Expense Tracker
            </Link>
            <Link to="/udhari-management-app" className="seo-link-card">
              <span className="seo-link-icon">&#128221;</span> Udhari Management
            </Link>
          </div>
        </div>
      </div>

      <LandingFooter />
    </div>
  );
};

export default BudgetPlannerIndia;
